import { render, staticRenderFns } from "./CompanyinformationForm.vue?vue&type=template&id=1aa6a97a&"
import script from "./CompanyinformationForm.vue?vue&type=script&lang=js&"
export * from "./CompanyinformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports